// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 353 ? "reactPlayerPreview" : chunkId) + "." + {"353":"453aa0bc","453":"82ca3f8b","741":"8f498127"}[chunkId] + ".chunk.js";
};